import ContentLayout from "components/layout/ContentLayout";
import React from "react";
import styled from "styled-components";
import { mediaMax, mediaMin } from "utils/theme";

const Wrapper = styled.div`
  width: 100%;

  ${mediaMax("lg")} {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: ${(props) => props.theme.zIndex.nav};

    display: flex;
    align-items: center;
    padding: 16px 0;

    &::before {
      display: block;
    }
  }

  &::before {
    content: "";

    position: absolute;
    bottom: 0;
    left: 0;
    z-index: -1;

    width: 100%;
    height: calc(1000% / 9);

    background: linear-gradient(
      to top,
      ${(props) => props.theme.colors.background} 80%,
      rgba(255, 255, 255, 0) 100%
    );
  }
`;

const Inner = styled(ContentLayout)`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 24px;

  ${mediaMin("lg")} {
    padding: 0;
  }
`;

interface Props {
  children: React.ReactNode;
}

const MobileFixedFooter: React.FC<Props> = ({ children }) => (
  <Wrapper>
    <Inner>{children}</Inner>
  </Wrapper>
);

export default MobileFixedFooter;
